export const validListValueValidator = (
  message = 'validators.requiredValidator',
  { list = [] }
) => ({
  validate: (value) => {
    const isExist = list.includes(value);
    return isExist || message;
  }
});
